<template>
  <a-table
    :scroll="{ y: 240 }"
    :loading="loading"
    size="middle"
    :pagination="false"
    :columns="columns"
    :data-source="data"
  >
    <template #bodyCell="{ text: color, column, record }">
      <template v-if="column.key === 'name'">
        <span >{{ record.name }} <a-tag class="tag__name" color="blue" v-if="record.type === TagTypeName[TagType.System]">{{ record.type }}</a-tag></span>
      </template>
      <template v-if="column.key === 'color'">
        <div class="tag__color" :style="{ backgroundColor: `#${color}` }"></div>
      </template>

      <template v-if="column.key === 'actions'">
        <a-tooltip>
          <template #title v-if="record?.type === TagTypeName[TagType.System]">
            Las etiquetas de sistema no pueden editarse o eliminarse porque ayudan a tener una mejor experiencia con funciones específicas.
          </template>
            <a-space :size="14">
              <a-button @click="handleOpenEditModal(record)" type="link" class="action__button" :disabled="record?.type == TagTypeName[TagType.System]">
                <EditOutlined />
              </a-button>

              <a-button @click="handleDeleteTag(record)" type="link" class="action__button" :disabled="record?.type == TagTypeName[TagType.System]">
                <DeleteOutlined />
              </a-button>
            </a-space>
        </a-tooltip>
      </template>
    </template>
  </a-table>
</template>

<script>
import { createVNode } from "vue";
import { useStore } from "vuex";

import { EditOutlined, DeleteOutlined } from "@ant-design/icons-vue";
import { Modal, message } from "ant-design-vue";
import { QuestionCircleOutlined } from "@ant-design/icons-vue";
import { TagTypeName, TagType } from "../../utils/enums";
import { tagsTableColumns } from "../../utils/constants";

export default {
  props: {
    data: {
      type: Array,
      required: true,
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    EditOutlined,
    DeleteOutlined,
  },
  setup(props, { emit }) {
    const store = useStore();

    const handleDeleteTag = ({ id: tagId, name: tagName }) => {
      Modal.confirm({
        title: `¿Estás seguro de eliminar la etiqueta "${tagName}"?`,
        content: "Recuerda que esta etiqueta se mantendrá en los tickets asignados.",
        icon: createVNode(QuestionCircleOutlined),
        centered: true,
        onOk: async () => {
          await store.dispatch("deleteTag", tagId);
          message.success("La etiqueta se eliminó correctamente");
          emit("update");
        },
        okText: "Eliminar",
        cancelText: "Cancelar",
      });
    };

    const handleOpenEditModal = (tagData) => {
      emit("on-tag-edit", tagData);
    };

    return {
      columns: tagsTableColumns,
      handleDeleteTag,
      handleOpenEditModal,
      TagTypeName,
      TagType,
    };
  },
};
</script>

<style lang="sass" scoped>
.tag__color
  width: 38px
  height: 8px
  border-radius: 3.5px

.tag__name
  margin-left: 8px

.action__button
  padding: 0
</style>
